import { Chevron, mkLink } from "../components/MkButton";
import { FEATURE_GROUPS } from "../site";

/** Everything the product does, at a glance: four short lists, each leading to its page. */
export function Features() {
	return (
		<section aria-labelledby="features-title" className="mk-section">
			<div className="mk-container">
				<div className="mk-reveal max-w-3xl">
					<h2 id="features-title" className="mk-h2">
						Everything your best shop assistant does.
					</h2>
					<p className="mk-lead mt-5 text-(--mk-ink-2)">
						For every shopper at once, at any hour, from the catalog
						you already have.
					</p>
				</div>
				<div className="mt-14 grid gap-x-10 gap-y-14 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
					{FEATURE_GROUPS.map((group) => (
						<div key={group.id} className="mk-reveal flex flex-col">
							<h3 className="mk-h3">{group.title}</h3>
							<p className="mt-1 text-(--mk-muted) text-[15px]">
								{group.summary}
							</p>
							<ul className="mt-5 divide-y divide-(--mk-line) border-(--mk-line) border-y text-[15px] text-(--mk-ink-2)">
								{group.items.map((item) => (
									<li
										key={item}
										className="py-3 leading-snug"
									>
										{item}
									</li>
								))}
							</ul>
							<a
								href={group.href}
								className={mkLink("mt-5 text-[15px]")}
							>
								{group.link}
								<Chevron />
							</a>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
